import React ,{useState ,useRef,useEffect}from 'react'
import {getBankBranchesList, getBanksList ,setUserDetails,CreateSplitSignatureFile} from './OrganizationPortalSlice'
import { connect } from 'react-redux';
import TextInput from '../../Shared/TextInput/TextInput';
import Autocomplete from '../../Shared/AutoCompleteInput/AutoCompleteInput.js';
import {validateInput, TextInputEnum} from '../../../utilities/validation/InputValidation';

function BankAccountInfo(props) {
 const [banksList, setBankList] = useState();
 const [branchesList, setBranchesList] = useState();

 const bankBranchRef = useRef();
 const bankRef = useRef();
 const accountNoRef = useRef();
 const emailRef = useRef();
 const [errorAccount, setErrorAccount] = useState('');
 const [errorMail, setErrorMail] = useState('');



  useEffect(() => {
    getAllBanks();
  }, []);

  const getAllBanks = async()=>{
    await props.getBanksList().then((res)=>{
      setBankList([...res.payload.Body]);
    });
  }
  const onBankChange=async(val)=>{
     props.setError('');
      if(val){
        var bank=banksList.find(b=>b.bankCode==val);
        props.setBankInfo({bankCode:val,bankName:bank.bankDescription,isAutomatedBank:bank.bankAgreement!==""})
        await props.getBankBranchesList({bankCode:val}).then((res)=>{
        setBranchesList([...res.payload.Body]);
        });
      }
  }

  const scrollInto = (inputName) => {
    const input = document.querySelector('input[name=' + inputName + ']');

    if (input !== null && window.innerHeight <= 350) {
      input.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };


  return (
    <div className='Debit_payment'>
    <div className='S_Title'>פרטי  הוראת קבע</div>
    <div className='S_SubTitle'>מלאו את פרטי הו"ק איתם תרצו לשלם</div>
    <div onClick={() => scrollInto('bank')} name='BankContainer'>
   <Autocomplete
                    value={props.bankInfo?.bankCode??""}
                    id='bank'
                    name='bank'
                    injectedValue={props.bankInfo?.bankName??""}
                    placeholder='בנק'
                    onSelectedChange={(e) => onBankChange(e.target.value)}
                    ref={bankRef}
                    required='required'
                    autofocus={true}
                    suggestions={banksList}
                    dataKey='bankCode'
                    dataValue='bankDescription'
                    form={{bankDescription : props.bankInfo?.bankName??""}}
        />
    </div>
    <div onClick={() => scrollInto('bankBranch')} name='BankBranchContainer'>
     <Autocomplete
                    value={props.bankInfo?.branchCode}
                    id='bankBranch'
                    name='bankBranch'
                    injectedValue={props.bankInfo?.branchCode}
                    placeholder='סניף'
                    onSelectedChange={(e) => {
                                                props.setBankInfo({...props.bankInfo,branchCode:e.target.value})
                                                props.setError('') }}
                    ref={bankBranchRef}
                    required='required'
                    autofocus={true}
                    suggestions={branchesList}
                    dataKey='branchCode'
                    dataValue='branchCode'
                    disabled ={props.bankInfo?.bankCode != '' ? '' : 'disabled'}
                    form={{branchCode: props.bankInfo?.branchCode?? '' }}
        />
    </div>
    <TextInput
                value={props.bankInfo?.bankAccountNo??""}
                error={errorAccount}
                id='accountNo'
                placeholder='מספר חשבון'
                onChange={(e) =>{
                props.setError('')
                setErrorAccount(validateInput(e.target.value, TextInputEnum.bankAccountNo));
                props.setBankInfo({...props.bankInfo,bankAccountNo:e.target.value})
              } }
                ref={accountNoRef}
                disabled ={props.bankInfo?.branchCode != '' ? '' : 'disabled'}

    />
    {props.bankInfo.isAutomatedBank &&
    <div className='info_section'>
       <span className='S_Title'> כתובת דואר אלקטרוני</span>
       <span className='S_SubTitle'> כתובת זו תשמש לקבלת  טופס חתימה על הו"ק</span>
       <TextInput
          value={props.bankInfo?.mail}
          error={errorMail}
          id='מייל'
          placeholder='מייל'
          onChange={(e) =>{
          props.setError('')
          setErrorMail(validateInput(e.target.value, TextInputEnum.Mail));
          props.setBankInfo({...props.bankInfo,mail:e.target.value})
        } }
          ref={emailRef}
        />
    </div>
    }

   </div>
  );
}

const mapStateToProps = (state) => ({
  userDetails:state.organizationPortal.userDetails,
  Bank:state.organizationPortal.userDetails.payment.Bank,
  currentStep: state.organizationPortal.steps.current,
  orgDetails: state.organizationPortal.orgDetails,
});

const mapDispatchToProps = {
  getBankBranchesList, getBanksList,setUserDetails,CreateSplitSignatureFile
};

export default connect(mapStateToProps, mapDispatchToProps)(BankAccountInfo);

